<template>
  <div
    class="vb-exercise-select"
    :draggable="draggable"
    :class="{ selected: selectedPath == path }"
    @load="(ev) => $emit('update')"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
    v-if="data.question || answers.length"
  >
    <div class="vb-exercise-select-question">
      {{ data.question }}
    </div>
    <div class="vb-exercise-select-answers">
      <div
        v-for="(answer, key) in answers"
        class="vb-exercise-select-answers-item"
        :class="{ selected: answer.selected }"
        :key="`answer-${key}`"
        @click.prevent="selectAnswer(key)"
      >
        <div class="vb-exercise-select-answers-item-dot">
          {{ alphabet[key] }}
        </div>
        <div class="vb-exercise-select-answers-item-text">
          {{ answer.answer }}
        </div>
      </div>
    </div>
  </div>
  <div
    class="vb-exercise-select-empty"
    :draggable="draggable"
    :class="{ selected: selectedPath == path }"
    @load="(ev) => $emit('update')"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
    v-else
  >
    Exercise select
  </div>
</template>
<script>
  import { cloneDeep } from 'lodash'

  export default {
    name: 'vb-exercise-select',
    props: {
      data: {
        required: true
      },
      path: {
        required: true
      },
      draggable: {
        type: Boolean
      },
      selectedPath: {
        type: String
      }
    },
    data () {
      return {
        answers: [],
        alphabet: [
          'a',
          'b',
          'c',
          'd',
          'e',
          'f',
          'g',
          'h',
          'i',
          'j',
          'k',
          'l',
          'm',
          'n',
          'o',
          'p',
          'q',
          'r',
          's',
          't',
          'u',
          'v',
          'w',
          'x',
          'y',
          'z',
        ]
      }
    },
    methods: {
      selectAnswer (index) {
        if (this.data.example)
          return
        
        this.answers = this.answers.map((a, i) => ({ ...a, selected: i == index }))

        this.$emit('answer', {
          prop: 'answers',
          value: this.answers,
          path: this.path
        })
      }
    },
    watch: {
      data () {
        this.answers = cloneDeep(this.data.answers || [])
      }
    },
    beforeMount () {
      this.answers = cloneDeep(this.data.answers || [])
    }
  }
</script>
<style lang="scss" scoped>
  .vb-exercise-select {
    font-size: 13px;
    // font-size: clamp(0em, 0.2em + 1vw, 1em);
    text-align: left;
    display: flex;
    flex-direction: column;

    &-question {
      color: #670000;
      border: 2px solid #ffaa00;
      border-radius: 10px;
      font-weight: 600;
      padding: 10px 15px;
    }

    &-answers {
      display: flex;
      flex-direction: column;

      &-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background-color: #d8d8d8;
        color: #818181;
        margin-top: .5rem;
        padding: 5px 10px 5px 5px;
        border-radius: 25px;

        &-dot {
          color: #fff;
          font-weight: 600;
          text-align: center;
          background-color: #afafaf;
          border-radius: 25px;
          width: 26px;
          height: 26px;
          padding: 2px 10px;
          margin-right: 5px;
        }


        &.selected {
          background-color: #44a9ff;
          color: #fff;
          font-weight: 600;
          .vb-exercise-select-answers-item-dot {
            background-color: #007af5;
          }
        }
      }
    }

    &.selected {
      border: .2rem dashed red;
    }
  }

  .vb-exercise-select-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    margin: .5rem;
    height: 2rem;
    border: .2rem dashed brown;

    &.selected {
      border: .2rem dashed red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VirtualBookViewer/VirtualBookExerciseSelect.vue